import React, { Component } from 'react';
import './Result.css';
import _ from 'lodash';
import TabContent from './TabContent/TabContent';
import PriorityError from './PriorityError/PriorityError';
import { Link } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goNextStep: false,
            tabs: [],
            competeData: [],
            benefitsData: [],
            competitorsGroupsData: [],
            resultData: [],
            priorityError: false,
            createdData: false,
            editData: true,
            //attractivnessData
            // segmentAttractiveness={this.props.segmentAttractiveness}
        };
    }

    componentWillMount = () => {

        let customerSegmentData = {
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData = {
            projectId: this.props.projectId,
            type: 'compete'
        }
        let competitorsData = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        let prioritiserData = {
            projectId: this.props.projectId,
            type: 'prioritizer'
        }

        let segmentAttractivness = {
            projectId: this.props.projectId,
            type: 'attractivness'
        }



        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompetitorsGroups(competitorsData);
        this.props.getCompete(competeData);
        this.props.getPrioritiser(prioritiserData);
        this.props.getAttractivness(segmentAttractivness)
    }

    componentWillReceiveProps(nextProps) {
        //competeData
        if (nextProps.compete.competeData.Items && _.isEmpty(this.state.competeData)) {

            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let data = []

                nextProps.compete.competeData.Items[0].dataBenefits.map(item => {
                    data.push(item)
                })

                this.setState({
                    competeData: data
                });
                let tabTitleArr = [];
                nextProps.compete.competeData.Items[0].dataBenefits.map(item => {
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);

                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);

                    let exist = this.state.tabs.find(r => r.groupId === item.groupId);

                    if (!exist) {
                        this.state.tabs.push({
                            groupId: item.groupId,
                            groupName: customerSegmentItem.groupName,
                            segmentId: item.segmentId,
                            segmentName: segmentData.name
                            //attractivnessId: uuidv1(),
                        });
                    }

                    if (_.isEmpty(nextProps.compete.benefitsData)) {
                        let benefitData = {
                            projectId: this.props.projectId,
                            type: 'benefitsLadder',
                            groupId: item.groupId,
                        }
                        //this.props.getBenefits(benefitData)
                    }

                });
            }

        }

        //competitorsGroupsData
        if (nextProps.compete.competitorsGroupsData.Count > 0 && nextProps.compete.competitorsGroupsData.Items[0] && nextProps.compete.competitorsGroupsData.Items[0].competitors && !_.isEmpty(nextProps.compete.competitorsGroupsData.Items[0].competitors) && _.isEmpty(this.state.competitorsGroupsData)) {
            nextProps.compete.competitorsGroupsData.Items[0].competitors.map(item => {
                this.state.competitorsGroupsData.push({
                    competitorId: item.competitorId,
                    competitorName: item.competitorName,
                    important: item.important,
                    indirect: item.indirect,
                    type: item.type,
                })
            })
        }

        if (nextProps.prioritizer && nextProps.prioritizer.createPrioritizerData.statusCode === 200 && this.state.goNextStep) {
            this.props.groupStateNext();
        }


        if (!_.isEmpty(nextProps.prioritizer.getPrioritizerData.Items) && _.isEmpty(this.state.resultData)) {

            this.setState({ createdData: false, editedData: true })
            if (!nextProps.prioritizer.getPrioritizerFetching && !_.isEmpty(nextProps.prioritizer.getPrioritizerData.Items)) {
                let data = []

                nextProps.prioritizer.getPrioritizerData.Items[0].prioritizer.map(item => {
                    data.push({
                        groupId: item.groupId,
                        segmentId: item.segmentId,
                        value: item.value,
                        checked: item.checked
                    })
                })

                this.setState({
                    resultData: data
                });
            }
        }
        if (_.isEmpty(nextProps.prioritizer.getPrioritizerData.Items) && !this.state.createdData) {
            this.setState({ createdData: true, editedData: false })
        }

    }

    onNextButtonClick = () => {

        let stepValidation;
        let dataArr = 0;
        this.state.resultData.map(item => {
            dataArr = dataArr + +item.value
        });

        let k = this.state.tabs.length
        let findZero = this.state.resultData.find(r => r.value === 0 || r.value === '0')

        if (!findZero && (dataArr === 100 * k)) {
            stepValidation = true;
        } else {
            stepValidation = false;
        }
        if (stepValidation) {
            if (this.state.createdData) {
                let body = {
                    projectId: this.props.projectId,
                    type: "prioritizer",
                    prioritizer: this.state.resultData
                }
                this.setState({ goNextStep: true })
                this.props.createPrioritiser(body)
            }
            if (this.state.editedData) {
                let body = {
                    id: this.props.prioritizer.getPrioritizerData.Items[0].id,
                    projectId: this.props.projectId,
                    type: "prioritizer",
                    prioritizer: this.state.resultData
                }

                this.setState({ goNextStep: true })
                this.props.editPrioritiser(body);
            }
        } else {
            this.priorityErrorModal();
        }
    }

    getResultData = (data) => {
        this.setState({ resultData: data })
    }

    priorityErrorModal = () => {
        this.setState({ priorityError: !this.state.priorityError })
    }

    downloadPDF = () => {
        let print = document.getElementById('print');
        html2canvas(print)
            .then((canvas) => {
                let wid
                let hgt
                const imgData = canvas.toDataURL('image/png', wid = canvas.width, hgt = canvas.height);
                let hratio = hgt/wid
                let pdf = new jsPDF('p','pt','a4');
                let width = pdf.internal.pageSize.width;
                let height = width * hratio
                pdf.addImage(imgData,'JPEG',0,0, width, height);
                pdf.save("prioritizer.pdf");
            });
    };

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-two arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-two arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>PRIORITIZER</h5>
                      </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className='card'  id="print" ref={el => (this.componentRef = el)}>
                                <div className="card-header">
                                    <h5>Results</h5>
                                </div>
                                <div className='card-body'>
                                    {(this.state.competitorsGroupsData.length === 0 || !this.props.segmentAttractiveness.attractivnessData.Items || _.isEmpty(this.state.competeData) || _.isEmpty(this.state.resultData)) && this.elementInfiniteLoad()}

                                    {(this.state.competitorsGroupsData.length > 0 && this.props.segmentAttractiveness.attractivnessData.Items && !_.isEmpty(this.state.competeData) && !_.isEmpty(this.state.resultData)) && <TabContent
                                        tabs={this.state.tabs}
                                        competeData={this.state.competeData}
                                        competitorsGroupsData={this.state.competitorsGroupsData}
                                        customerSegmentData={this.props.compete.customerSegmentData}
                                        getResultData={this.getResultData}
                                        resultData={this.state.resultData}
                                        segmentAttractiveness={this.props.segmentAttractiveness}
                                    />}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>


                                    <Link to={'/differential-advantage/' + this.props.projectId} className='btn btn-success'> Next </Link>
                                    <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                    <div className='btn empty-btn default' onClick={this.downloadPDF}
                                    >Save PDF</div>
                                    <ReactToPrint
                                        trigger={() => <a className='btn empty-btn default' href="#">Print</a>}
                                        content={() => this.componentRef}
                                    />
                                    <div className='btn empty-btn default'
                                        onClick={() => this.props.groupStateBack()}>Back</div>


                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.priorityError &&
                        <PriorityError
                            priorityErrorModal={this.priorityErrorModal}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default (Result);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/Result/Result.jsx